import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .ReactTable .rt-thead .rt-th {
    padding: 10px;
    text-transform: uppercase;
    color: #fff;
    background: ${colors.primary.dark};
    font-size: 14px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    font-weight: bold;
  }

  .ReactTable .rt-thead .rt-th.-sort-asc,
  .ReactTable .rt-thead .rt-td.-sort-asc,
  .ReactTable .rt-thead .rt-th.-sort-desc,
  .ReactTable .rt-thead .rt-td.-sort-desc {
    color: #222;
  }
  .ReactTable .rt-td:empty:after {
    content: "-";
    text-align: center;
    width: 100%;
    display: inline-block;
  }

  .ReactTable .rt-tbody .rt-td {
    align-self: center;
  }

  .ReactTable .rt-th.-sort-desc:before {
    content: "▼";
    position: absolute;
    right: 10px;
    top: 9px;
    font-size: 1em;
  }

  .ReactTable .rt-th.-sort-asc:before {
    content: "▲";
    position: absolute;
    right: 10px;
    top: 9px;
    font-size: 1em;
  }

  .ReactTable .rt-thead .rt-th.-sort-asc,
  .ReactTable .rt-thead .rt-td.-sort-asc,
  .ReactTable .rt-thead .rt-th.-sort-desc,
  .ReactTable .rt-thead .rt-td.-sort-desc {
    color: #fff;
  }

  .ReactTable .rt-thead .rt-th.-sort-desc,
  .ReactTable .rt-thead .rt-td.-sort-desc,
  .ReactTable .rt-thead .rt-th.-sort-asc,
  .ReactTable .rt-thead .rt-td.-sort-asc {
    box-shadow: inset 0 -3px 0 0 ${colors.accent.normal};
  }

  .ReactTable .-pagination .-previous,
  .ReactTable .-pagination .-center,
  .ReactTable .-pagination .-next {
    width: 100%;
    flex: none;
    align-self: center;
  }

  @media only screen and (min-width: 768px) {
    .ReactTable .-pagination .-previous,
    .ReactTable .-pagination .-center,
    .ReactTable .-pagination .-next {
      width: auto;
      flex: 1 1 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/support/data-table/styles.js